import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useRefreshListener } from '../hooks/useRefreshListener';
import { Layout } from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { Trophy, Star, Target, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const CAT = {
  estrela: { icon: Star, label: 'Estrela', color: 'from-amber-400 to-orange-500', emoji: '⭐' },
  top: { icon: Trophy, label: 'Top', color: 'from-emerald-400 to-teal-600', emoji: '🏆' },
  marco: { icon: Target, label: 'Marco', color: 'from-indigo-400 to-purple-600', emoji: '🎯' },
};

const RecognitionsWallPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API_URL}/admin-alerts/recognitions/mine`);
      setItems(r.data || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { fetchData(); }, []);
  useRefreshListener(fetchData);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-5xl">
        <div className="flex items-center gap-3 mb-8">
          <Trophy className="w-8 h-8 text-emerald-600" />
          <div>
            <h1 className="text-3xl font-bold text-slate-800">Os Meus Reconhecimentos</h1>
            <p className="text-sm text-slate-500">A tua coleção pessoal de troféus 🏆</p>
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-emerald-600" /></div>
        ) : items.length === 0 ? (
          <div className="text-center py-20" data-testid="recognitions-empty">
            <Trophy className="w-16 h-16 text-slate-200 mx-auto mb-4" />
            <p className="text-slate-400 text-lg">Ainda não recebeste reconhecimentos.</p>
            <p className="text-slate-400 text-sm mt-1">Continua a dar o teu melhor!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="recognitions-list">
            {items.map(r => {
              const c = CAT[r.severity] || CAT.estrela;
              const Icon = c.icon;
              return (
                <Card key={r.id} className="overflow-hidden hover:shadow-lg transition-shadow" data-testid={`recognition-${r.id}`}>
                  <div className={`bg-gradient-to-r ${c.color} px-4 py-3 flex items-center gap-3`}>
                    <Icon className="w-6 h-6 text-white" />
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] uppercase tracking-widest text-white/80 font-bold">{c.emoji} {c.label}</p>
                      <p className="text-sm font-bold text-white truncate">De: {r.sender_name}</p>
                    </div>
                    <span className="text-[10px] text-white/80">{new Date(r.created_at).toLocaleDateString('pt-PT')}</span>
                  </div>
                  <CardContent className="p-4">
                    <p className="text-sm text-slate-700 whitespace-pre-wrap">{r.message}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default RecognitionsWallPage;
